import { render, staticRenderFns } from "./Carta.vue?vue&type=template&id=54817dc2&scoped=true"
import script from "./Carta.vue?vue&type=script&lang=js"
export * from "./Carta.vue?vue&type=script&lang=js"
import style0 from "./Carta.vue?vue&type=style&index=0&id=54817dc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54817dc2",
  null
  
)

export default component.exports